import { AppBar, IconButton, Menu, MenuItem, Toolbar, Typography } from "@material-ui/core";
import classNames from "classnames";
import { useState, useCallback } from "react";
import { DefaultProfile, StocqLogo } from "../../../images";
import Image from "../image/image";
import styles from "./header.module.scss";
import KeyboardArrowDownRoundedIcon from "@material-ui/icons/KeyboardArrowDownRounded";
import SaveAltOutlinedIcon from "@material-ui/icons/SaveAltOutlined";
import { useApi, useRouter } from "hooks";
import { redirectTo } from "utils";
import { logout } from "apis";
import { Path } from "enums";
import { useContext } from "react";
import { AppContext, DownloadsContext } from "contexts";
import { locale } from "localization/en";

const Header = ({ onClick }) => {
  const [open, setOpen] = useState(false);
  const { toggleLoading } = useContext(AppContext);
  const { push } = useRouter();
  const { newDownloads: newDownloadFiles } = useContext(DownloadsContext);
  const newDownloads = newDownloadFiles.length;

  const { request: logoutRequest } = useApi({
    api: logout,
  });

  const logoutCb = useCallback(async () => {
    toggleLoading(true);
    await logoutRequest();
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    toggleLoading(false);
    redirectTo(Path.Auth);
  }, [logoutRequest, toggleLoading]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div id="header">
      <AppBar className={classNames(styles.locqHeaderContainer)}>
        <Toolbar disableGutters>
          <div className={styles.logoContainer}>
            <Image src={StocqLogo} className={styles.logo} />
          </div>
          <div className={styles.toolbarContainer}>
            <Typography variant="h6" className={styles.title}>
              {locale.stocqHOS}
            </Typography>
            <div className={styles.menuContainer}>
              {newDownloads > 0 && (
                <IconButton
                  className={styles.downloadsButton}
                  aria-label={locale.downloads}
                  onClick={() => push(Path.Downloads)}
                >
                  <SaveAltOutlinedIcon className={styles.downloadsIcon} />
                  <span className={classNames(styles.newDownloadsBadge, styles.iconBadge)}>
                    {newDownloads > 99 ? "99+" : newDownloads}
                  </span>
                </IconButton>
              )}
              <IconButton
                className={styles.profileDiv}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpen}
              >
                <Image src={DefaultProfile} className={styles.profile} />
                <KeyboardArrowDownRoundedIcon className={styles.caretIcon} />
              </IconButton>
              <Menu
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                keepMounted
                open={open}
                className={styles.menu}
                onClose={handleClose}
              >
                <MenuItem
                  className={styles.menuItem}
                  onClick={() => {
                    handleClose();
                    push(Path.Downloads);
                  }}
                >
                  {locale.downloads}
                  {newDownloads > 0 && (
                    <span className={styles.newDownloadsBadge}>
                      {newDownloads > 99 ? "99+" : newDownloads}
                    </span>
                  )}
                </MenuItem>
                <MenuItem className={styles.menuItem} onClick={logoutCb}>
                  {locale.logout}
                </MenuItem>
              </Menu>
            </div>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Header;
